import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { StepperButton } from './stepper-button';
import { cn } from '../../../utils';
export const UncontrolledInput = forwardRef(({ name, type, error, ...props }, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const handleIncrement = useCallback(() => {
        if (!inputRef.current) {
            return;
        }
        const currentValue = inputRef.current.value;
        const step = props.step ? parseFloat(props.step.toString()) : 1;
        const newValue = parseFloat(currentValue || '0') + step;
        if (props.max && newValue > parseFloat(props.max.toString())) {
            return;
        }
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, newValue.toString());
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
    }, [props.max, props.step]);
    const handleDecrement = useCallback(() => {
        if (!inputRef.current) {
            return;
        }
        const currentValue = inputRef.current.value;
        const step = props.step ? parseFloat(props.step.toString()) : 1;
        const newValue = parseFloat(currentValue || '0') - step;
        if (props.min && newValue < parseFloat(props.min.toString())) {
            return;
        }
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, newValue.toString());
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
    }, [props.min, props.step]);
    return (_jsxs("div", { className: cn('relative flex rounded-xl border border-gray-100 overflow-hidden', 'focus-within:outline focus-within:outline-2 focus-within:outline-indigo-400 focus-within:outline-offset-2', {
            'border-red-500 focus-within:outline-red-500': error,
        }, props.className), children: [_jsx("input", { ...props, ref: inputRef, type: type, id: name, name: name, className: cn('flex-1', 'px-3 min-h-12 text-sm text-gray-700', 'placeholder:text-sm placeholder:text-gray-400', '[appearance:textfield]', '[&::-webkit-outer-spin-button]:appearance-none', '[&::-webkit-inner-spin-button]:appearance-none', 'focus:outline-none', 'border-0', {
                    'text-red-500 placeholder:text-red-300': error,
                    'cursor-not-allowed': props.disabled,
                }) }), type === 'number' && (_jsxs("div", { className: "flex flex-col border-l divide-y border-gray-100", children: [_jsx(StepperButton, { direction: "up", onClick: handleIncrement }), _jsx(StepperButton, { direction: "down", onClick: handleDecrement })] }))] }));
});
UncontrolledInput.displayName = 'UncontrolledInput';
